import { DeleteOutlined, FormOutlined, RollbackOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import { useEffect, useState } from "react";

// Internal Imports
import ButtonGrid from "../../../common/components/ButtonGrid/ButtonGrid";
import DetailTable from "../../../common/components/DetailTable/DetailTable";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import OutLineButton from "../../../common/components/OutLineButton/OutLineButton";
import { COLORS } from "../../../common/constants/colors";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import useListAttribute from "../../../hooks/useListAttribute";
import { TypeAttribute } from "../../../interfaces/IAttribute";
import IColumn from "../../../interfaces/IColumn";
import { IUserAtribute } from "../../../interfaces/IUser";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import Paint from "../../../common/components/Paint/Paint";
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import '../Usuarios.css';
import Modal from "../../../common/components/Modal/Modal";
import AddUpdateAttribute from "../../Atributos/AddUpdateAttribute";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";
import { LoadingIcon } from "../../../common/constants/cssElements";


// Interface
interface Props {
    mode: Mode;
    setCanGoBack: React.Dispatch<React.SetStateAction<boolean>>;
}


const StepFive = ({ setCanGoBack, mode }: Props) => {
    // States
    const { listAttribute, loadingAttr, setListAttribute } = useListAttribute();
    const { setUserInformationForm, userInformationForm, setStatusUserForm, loadingSubmit, setLoadingSubmit } = useForm();
    const [detailUpdate, setDetailUpdate] = useState<IUserAtribute>();
    const [listUsuarioAttribute, setListUsuarioAttribute] = useState<IUserAtribute[]>([]);

    // Modal ShortCut AddAttr
    const { listDepartment, loadingDeparment } = useListDepartmentByUer();
    const [visibleModal, setVisibleModal] = useState<boolean>(false);

    // Const
    const columns: IColumn[] = [
        {
            title: 'Atributo',
            dataIndex: 'atributoNombre',
        },
        {
            title: 'Valor',
            dataIndex: 'atributoValor',
        },

        {
            title: "",
            dataIndex: "",
            render: (detail: IUserAtribute) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonGrid color={COLORS.black_text_color4} active={detailUpdate?.atributoID !== detail.atributoID && !!detailUpdate ? false : true} icon={detailUpdate?.atributoID === detail.atributoID ? <RollbackOutlined /> : <FormOutlined />} method={() => selectDetail(detail)} />
                    <nav>&nbsp;&nbsp;</nav>
                    <ButtonGrid color={COLORS.black_text_color4} active={!detailUpdate} icon={<DeleteOutlined />} method={() => removeDetail(detail.atributoID)} />
                </div>
            )
        }
    ];

    // Methods
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.atributoID) {
            errors.atributoID = "Requerido";
        }

        if (!values.atributoValor) {
            errors.atributoValor = "Requerido";
        }

        return errors;
    }

    const clearForm = () => {
        UserForm.setValues({
            atributoID: "",
            atributoValor: "",
        })
    }
    const addDetail = () => {

        let attInternal = listAttribute.find(atrr => atrr.atributoID === parseInt(UserForm.values.atributoID))!;

        const newAttr: IUserAtribute = {
            usuarioAtributoID: 0,
            usuarioID: userInformationForm!.usuarioID,
            atributoID: parseInt(UserForm.values.atributoID),
            atributoNombre: attInternal.nombre,
            atributoDetalleID: attInternal.atributoTipo === TypeAttribute.Detalle ? attInternal.atributoDetalle.find(x => x.atributoValor === UserForm.values.atributoValor)!.atributoDetalleID : null,//
            atributoValor: UserForm.values.atributoValor
        }

        let listInternal = userInformationForm!.usuarioAtributo!;
        listInternal.push(newAttr);

        setUserInformationForm({ ...userInformationForm!, usuarioAtributo: listInternal! });
        clearForm();
    }

    const selectDetail = (attribute: IUserAtribute) => {
        if (!detailUpdate) {
            setDetailUpdate(attribute);
            UserForm.setValues({
                atributoID: attribute.atributoID.toString(),
                atributoValor: attribute.atributoValor
            })
        } else {
            setDetailUpdate(undefined);
            clearForm();
        }
    }

    const updateDetail = () => {
        let attInternal = listAttribute.find(atrr => atrr?.atributoID === parseInt(UserForm.values.atributoID))!;
        let internal: IUserAtribute = {
            usuarioAtributoID: detailUpdate!.usuarioAtributoID,
            usuarioID: detailUpdate!.usuarioID,
            atributoID: attInternal!.atributoID!,
            atributoNombre: attInternal.nombre,
            atributoDetalleID: attInternal.atributoTipo === TypeAttribute.Detalle ? attInternal.atributoDetalle.find(x => x.atributoValor === UserForm.values.atributoValor)!.atributoDetalleID : null,//
            atributoValor: UserForm.values.atributoValor
        };

        let listInternal = userInformationForm!.usuarioAtributo!;
        let index = listInternal.findIndex(x => x.atributoID === detailUpdate!.atributoID);

        listInternal[index] = internal!;

        setUserInformationForm({ ...userInformationForm!, usuarioAtributo: [...listInternal!] });

        // Finally
        setDetailUpdate(undefined);
        clearForm();
    }

    const removeDetail = (attrID: number) => {
        const listInternal = userInformationForm!.usuarioAtributo!.filter(attr => attr.atributoID !== attrID);
        setUserInformationForm({ ...userInformationForm!, usuarioAtributo: [...listInternal!] });
    }

    // Form
    const UserForm = useFormik({
        initialValues: { atributoID: "", atributoValor: "" },
        validate: validations,
        onSubmit: (values: any) => !!detailUpdate ? updateDetail() : addDetail(),
    });

    // Effects
    useEffect(() => {
        setListUsuarioAttribute(!!userInformationForm?.usuarioAtributo ? [...userInformationForm?.usuarioAtributo!] : []);
    }, [userInformationForm])

    useEffect(() => {
        if (!!detailUpdate) {
            setStatusUserForm(false);
            setCanGoBack(false);
        } else {
            setStatusUserForm(true);
            setCanGoBack(true);
        }
    }, [detailUpdate]);

    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Atributo:</label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
                        <SelectBox
                            value={UserForm.values.atributoID}
                            placeholder={"Atributo"}
                            disabled={false}
                            allowClear={false}
                            loading={loadingAttr}
                            onChange={(value: string) => UserForm.setValues({ atributoID: value, atributoValor: "" })}
                            options={listAttribute.filter(attr => attr.departamentoID === userInformationForm?.usuarioProyecto?.departamentoID && (!userInformationForm!.usuarioAtributo!.map(x => x.atributoID).includes(attr.atributoID!) || attr.atributoID === detailUpdate?.atributoID)).map(attr => ({ key: attr.nombre, value: attr.atributoID?.toString(), text: attr.nombre }))}
                            backgroundColor={COLORS.white_color2(1)}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                        />
                        <nav className="addShortCut" onClick={() => setVisibleModal(true)}><i className="fa-solid fa-plus"></i></nav>
                    </div>
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{UserForm.errors.atributoID && UserForm.errors.atributoID}</Paint>
                    </p>
                </MarginInput>

                {!!listAttribute && !!UserForm.values.atributoID && listAttribute.find(atrr => atrr.atributoID === parseInt(UserForm.values.atributoID))?.atributoTipo === TypeAttribute.Detalle
                    ? (
                        <MarginInput width="45%">
                            <label>Valor</label>
                            <SelectBox
                                value={UserForm.values.atributoValor}
                                placeholder={"Valor"}
                                disabled={false}
                                allowClear={false}
                                loading={false}
                                onChange={(value: string) => UserForm.setFieldValue("atributoValor", value)}
                                options={!!listAttribute ? listAttribute.find(x => x.atributoID!.toString() === UserForm.values.atributoID)!.atributoDetalle.map(x => ({ key: x.atributoValor + x.atributoID, value: x.atributoValor, text: x.atributoValor })) : []}
                                backgroundColor={COLORS.white_color2(1)}
                                borderColor={COLORS.black_text_color3}
                                textColor={COLORS.black_text_color1}
                            />
                            <p className={globalStyle.error}>
                                <Paint color={COLORS.red_error2}>{UserForm.errors.atributoValor && UserForm.errors.atributoValor}</Paint>
                            </p>
                        </MarginInput>

                    )
                    : (
                        <MarginInput width="45%">
                            <label>Valor:</label>
                            <EditTextForm
                                value={UserForm.values.atributoValor}
                                onChange={UserForm.handleChange}
                                backgroundcolor={COLORS.white_color2(1)}
                                name={"atributoValor"}
                                placeholder={"Valor"}
                                borderColor={COLORS.black_text_color3}
                                textColor={COLORS.black_text_color1}
                                active={true}
                                type={'text'}
                            />
                            <p className={globalStyle.error}>
                                <Paint color={COLORS.red_error2}>{UserForm.errors.atributoValor && UserForm.errors.atributoValor}</Paint>
                            </p>
                        </MarginInput>
                    )

                }

            </GroupRow>

            <div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                    <MarginInput width="40%">
                        <OutLineButton color={!!detailUpdate ? COLORS.white_color1 : COLORS.blue_active} backgroundColor={!!detailUpdate ? COLORS.blue_main(1) : COLORS.transparent_color1} text={!!detailUpdate ? "Modificar Attributo" : "Añadir Attributo"} method={UserForm.handleSubmit} />
                    </MarginInput>
                </div>
                <DetailTable
                    props={{ rowKey: (record: any) => record.atributoNombre }}
                    dataSource={listUsuarioAttribute}
                    columns={columns}
                    loading={false}
                    paginationActive={!detailUpdate}
                />
            </div>


            <Modal props={{ style: { top: '-45px' } }} width={"50%"} title={<nav className="modal_title"> Crear <Paint color={COLORS.blue_main(1)}>Atributo</Paint></nav>} visible={visibleModal} setVisible={setVisibleModal} askBeforeClose={true}>
                <AddUpdateAttribute defaultDepartmentGUID={userInformationForm?.usuarioProyecto!.departamentoGUID!} setDataList={setListAttribute} dataList={listAttribute} attribute={undefined} mode={'Add'} setAttributeUpdate={undefined} setAddUpdateModal={setVisibleModal} listDepartment={listDepartment} loadingDeparment={loadingDeparment} />
            </Modal>

            <Modal props={{ style: { top: '-45px' } }} closable={false} width={"30%"} title={"Cargando..."} visible={loadingSubmit} setVisible={setLoadingSubmit} askBeforeClose={false}>
                <div className="stepThree_loading">
                    <LoadingIcon color={COLORS.blue_main(1)} size={'3em'} />
                </div>
            </Modal>
        </div>
    );
}

export default StepFive;